import React, {useEffect, useMemo, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import './Projects.scss';
import PGE_LOGO from '../../assets/pge_logo.png';
import EON_LOGO from '../../assets/eon_logo.png';
import Pge from './Pge';
import Stoen from './Stoen';

const getTabFromType = type => {
  if (type === 'eon') {
    return 2;
  }
  if (type === 'pge') {
    return 1;
  }
  return 1;
};

const getUrlDateFilters = (typeParam, updatedFrom, updatedTo, ownerParam) => {
  if (typeParam !== 'pge' && typeParam !== 'eon') {
    return {};
  }

  const filters = {};

  if (updatedFrom) {
    filters.fromLastModificationDate = updatedFrom;
  }
  if (updatedTo) {
    filters.toLastModificationDate = updatedTo;
  }
  // Ownership from the reminder-email link: scope the list to the recipient so it
  // shows the same projects as the email body.
  if (typeParam === 'pge' && ownerParam) {
    filters.personResponsibleForProjectId = ownerParam;
  }
  if (typeParam === 'eon' && ownerParam) {
    filters.designerId = ownerParam;
  }

  return filters;
};

const Projects = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const urlProjectId = searchParams.get('id');
  const updatedFromParam = searchParams.get('updatedfrom');
  const updatedToParam = searchParams.get('updatedto');
  const ownerParam = searchParams.get('personresponsible') || searchParams.get('designer');
  const urlDateFilters = useMemo(
    () => getUrlDateFilters(typeParam, updatedFromParam, updatedToParam, ownerParam),
    [typeParam, updatedFromParam, updatedToParam, ownerParam]
  );
  const [tab, setTab] = useState(() => getTabFromType(typeParam));
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [displayArchiveBackground, setDisplayArchiveBackground] = useState(false);

  useEffect(() => {
    if (typeParam === 'pge' || typeParam === 'eon') {
      setTab(getTabFromType(typeParam));
    }
  }, [typeParam]);

  const changeTab = tabId => {
    if (tabId !== tab) {
      setTab(tabId);
      setDisplayArchiveBackground(false);
    }
  };

  const changeRecordsPerPage = (number) => {
    setRecordsPerPage(number);
  };

  const toggleArchiveBackground = () => {
    setDisplayArchiveBackground(!displayArchiveBackground);
  };

  const clearProjectUrlParams = () => {
    if (searchParams.has('type') || searchParams.has('id')) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('type');
      nextParams.delete('id');
      setSearchParams(nextParams, { replace: true });
    }
  };

  const clearUrlDateFilters = () => {
    if (searchParams.has('updatedfrom') || searchParams.has('updatedto') || searchParams.has('personresponsible') || searchParams.has('designer') || searchParams.has('type')) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('updatedfrom');
      nextParams.delete('updatedto');
      nextParams.delete('personresponsible');
      nextParams.delete('designer');
      nextParams.delete('type');
      setSearchParams(nextParams, { replace: true });
    }
  };

  return (
    <div className={displayArchiveBackground ? 'Projects--archive' : 'Projects'}>
      <div className='tabBar'>
        <div className={tab === 1 ? 'tabButton--selected' : 'tabButton'} onClick={() => changeTab(1)}>
          <img src={PGE_LOGO} className='logo' alt='logo' />
        </div>
        <div className={tab === 2 ? 'tabButton--selected' : 'tabButton'} onClick={() => changeTab(2)}>
          <img src={EON_LOGO} className='logo' alt='logo'/>
        </div>
      </div>
      <div className='tabContent'>
        {tab === 1
          ? <Pge
            recordsPerPage={recordsPerPage}
            changeRecordsPerPage={changeRecordsPerPage}
            toggleArchiveBackground={toggleArchiveBackground}
            urlProjectId={typeParam === 'pge' ? urlProjectId : null}
            onUrlProjectClose={clearProjectUrlParams}
            urlDateFilters={typeParam === 'pge' ? urlDateFilters : {}}
            onUrlDateFiltersClear={clearUrlDateFilters}
          />
          : <Stoen
            recordsPerPage={recordsPerPage}
            changeRecordsPerPage={changeRecordsPerPage}
            toggleArchiveBackground={toggleArchiveBackground}
            urlProjectId={typeParam === 'eon' ? urlProjectId : null}
            onUrlProjectClose={clearProjectUrlParams}
            urlDateFilters={typeParam === 'eon' ? urlDateFilters : {}}
            onUrlDateFiltersClear={clearUrlDateFilters}
          />
        }
      </div>
    </div>
  );
};

export default Projects;
